module.exports = __webpack_public_path__ + "static/john-robbins-headshot-20200622.79be319e.jpg";